import { useEffect, useState } from "react"
import { PlanAI } from "../../interfaces/PlanesInterface"
import { API_AUDITORIAS } from "../../features/constants";
import { Users } from "../../interfaces/UserInterface";


interface PlanesProps{
    planSelect?: PlanAI | undefined
    setPlanSelect: React.Dispatch<React.SetStateAction<PlanAI | undefined>>
    update?: Boolean
}

export const ListaPlanesAuditoriasInternas = ({planSelect,setPlanSelect,update}:PlanesProps)=>{
    
    let localUser = localStorage.getItem("localUser");
    let user:Users = localUser?JSON.parse(localUser):undefined;

    const [planesList, setPlanesList] = useState<PlanAI[]>([]);



    useEffect(()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };

        fetch(API_AUDITORIAS + "/Lista-de-Planes-AI",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then((data:PlanAI[])=>{
                setPlanesList(data);
            })
    },[update])

    
    const nuevoPlan = ()=>{
        //if(planesList[planesList.length-1].Id!==""){
        //    setPlanesList([...planesList,{Id:"",Lugar:"",Fecha:"",Nro_auditoria:"",Objetivo:"",Alcance:"",Criterios:""}])
        //}
        if(planesList.length>0){
            let pln = planesList[planesList.length-1];
            setPlanSelect({
                        Id:"",
                        Lugar:pln.Lugar,
                        Fecha:"",
                        Nro_auditoria:"",
                        Objetivo:pln.Objetivo,
                        Alcance: pln.Alcance,
                        Criterios: pln.Criterios
                        });
        }else{
            setPlanSelect({Id:"",Lugar:"",Fecha:"",Nro_auditoria:"",Objetivo:"",Alcance:"",Criterios:""});
        }
    }

    return(
    <>
        <div 
            className="d-flex flex-column justify-cotent-center align-items-center p-1"
            style={{backgroundColor:"rgba(219, 219, 219, 0.5)"}}
        >
            {
                planesList.map(plan=>(
                    <div className="mx-1" key={plan.Id.toString()}>
                        <button 
                            className={planSelect?.Id===plan.Id?"btn btn-sm btn-dark" : "btn btn-sm btn-outline-secondary"}
                            onClick={()=>setPlanSelect(plan)}
                        >
                           {plan.Nro_auditoria} | {plan.Fecha.slice(8,10)}/{plan.Fecha.slice(5,7)}/{plan.Fecha.slice(0,4)}
                        </button>
                    </div>
                ))
            }
            <div className="m-1">
                <button
                    className="btn btn-sm btn-outline-primary"
                    disabled={user.Auditoria==="2"?false:true}
                    onClick={()=>nuevoPlan()}
                >NUEVO PLAN</button>
            </div>
            {
                planSelect?planSelect.Id===""?
                <div
                    className="alert alert-warning"
                    role="alert"
                >
                    <h4 className="alert-heading">Nuevo Plan</h4>
                    <p>Para completar los campos con los valores del último plan debe hacer doble click en el campo correspondiente</p>
                    <hr />
                    <p className="mb-0">Esta opción sólo está disponible en la carga de datos previa a la creación del plan.</p>
                </div>
                :
                <div></div>
                :
                <div></div>
            }
            
            {
                user.Auditoria!=="2"?
                <div
                    className="alert alert-secondary ocultar-al-imprimir"
                    role="alert"
                >
                    <h4 className="alert-heading">Usuario Restringido</h4>
                    <p>El usuario solo tiene permisos de lectura</p>
                    <hr />
                    <p className="mb-0">Debe iniciar sesión con un perfil de Auditor Interno para tener acceso completo
                    </p>
                </div>
                :
                <div></div>
                
            }

        </div>
    </>
    )
}